import { graphql } from "../../gql";
import { useQuery } from "@apollo/client";

const UserActivePlansStatusQuery = graphql(`
  query userActivePlansStatus {
    userActivePlansStatus {
      hasActive1on1Plan
      hasActiveGroupPlan
    }
  }
`);

export function useUserActivePlansStatus(skip = false) {
  const { data, loading, refetch, error } = useQuery(
    UserActivePlansStatusQuery,
    {
      skip,
      fetchPolicy: "network-only",
    },
  );

  return {
    hasActive1on1Plan: data?.userActivePlansStatus?.hasActive1on1Plan ?? false,
    hasActiveGroupPlan:
      data?.userActivePlansStatus?.hasActiveGroupPlan ?? false,
    loading,
    refetch,
    error,
  };
}
